









import Vue from 'vue';
import CvsContainer from '../../containers/cvs/index.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvsStore from '@/containers/cvs/store';
import * as CoverLettersStore from '@/containers/cover-letters/store';

const fetch = async () => {
  await Promise.all([
    store.dispatch(CvsStore.GetCvs.namespaced(null)),
    store.dispatch(CoverLettersStore.GetCoverLetters.namespaced(null)),
  ]);
};

export default Vue.extend({
  // NOTE: DO NOTE reset state
  components: {
    CvsContainer,
  },
  mixins: [PageFetchHook(fetch)],
});
